export default "__VITE_ASSET__313f8b3b__"